<template>
    <div>
    <el-row :gutter="20">
        <el-col :span="16">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>日志</span>
                </div>
                <div>
                    <el-table
                        :data="tableData"
                        border
                        aligh="center" >
                        <el-table-column fixed prop="date" label="日期" align="center"> </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.$index, scope.row)" type="text" size="small">查看</el-button>
                                <!-- <a :href="downUrl" target="_blank"> -->
                                    <el-button type="text" size="small" @click="handleDownload(scope.row)">下载</el-button>
                                <!-- </a> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                    small
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    :total="totalCount">
                </el-pagination>
            </el-card>
        </el-col>

    </el-row>
    </div>
</template>

<script>

// import axios from 'axios';
import { Config } from '@/config/config';
import { Message } from 'element-ui';
import { client } from "@/utils/client";

export default {
    name: "LogTable",
    methods: {
        handleClick(index, row) {
            console.log('========')
            console.log(index)
            console.log(row);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            //
            var offset = (val - 1) * this.pageSize
            var limit = Math.min(offset + this.pageSize, this.allData.length)
            this.tableData = this.allData.slice(offset, limit)
        },
        handleDownload(row) {
            console.log("handleDownload" + row)
            window.open(Config.url + '/api/v1/console/logs?filename='+row.date)
        }
    },
    components: {},
    beforeCreate: function() {
        client.get('/api/v2/devices/')
        .then(resp => {
            console.log(resp.data)
            var logData = []
            resp.data.Logs.forEach(v => {
                if (v.endsWith(".log")) {
                    logData.push({date: v})
                }
            })
            this.allData = logData
            this.totalCount = this.allData.length
            console.log(this.allData)
            this.tableData = this.allData.slice(0, this.pageSize)
        })
        .catch(err => {
            Message.warning({message: this.$t("alexa.active_code_message_exception")})
        })
    },
    // created: function () {},
    data() {
        return {
            pageSize: 5,
            totalCount: 0,
            tableData: [],
            allData: []
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Log.vue